import { createAction } from 'redux-act';
// add Hierarchy action
const addHierarchyRequest = createAction('ADD_HIERARCHY_REQUEST', data => data);
const addHierarchySuccess = createAction('ADD_HIERARCHY_SUCCESS', data => data);
const addHierarchyError = createAction('ADD_HIERARCHY_ERROR');

// get Hierarchy action
const getAllHierarchyRequest = createAction('GET_ALL_HIERARCHY_REQUEST', data => data);
const getAllHierarchySuccess = createAction('GET_ALL_HIERARCHY_SUCCESS', data => data);
const getAllHierarchyError = createAction('GET_ALL_HIERARCHY_ERROR');

// Update Hierarchy action
const updateHierarchyRequest = createAction('UPDATE_HIERARCHY_REQUEST', data => data);
const updateHierarchySuccess = createAction('UPDATE_HIERARCHY_SUCCESS', data => data);
const updateHierarchyError = createAction('UPDATE_HIERARCHY_ERROR');

// Delete Hierarchy action
const deleteHierarchyRequest = createAction('DELETE_HIERARCHY_REQUEST', data => data);
const deleteHierarchySuccess = createAction('DELETE_HIERARCHY_SUCCESS', data => data);
const deleteHierarchyError = createAction('DELETE_HIERARCHY_ERROR');

// clear existing Hierarchy action
const handleClearHierarchyStore = createAction('HANDLE_CLEAR_HIERARCHY_STORE',data => data);

export default {
    addHierarchyRequest,
    addHierarchySuccess,
    addHierarchyError,

    getAllHierarchyRequest,
    getAllHierarchySuccess,
    getAllHierarchyError,

    updateHierarchyRequest,
    updateHierarchySuccess,
    updateHierarchyError,

    deleteHierarchyRequest,
    deleteHierarchySuccess,
    deleteHierarchyError,
    
    handleClearHierarchyStore,
}